import React from 'react'
import {
    Box,
    Button,
    HStack,
    VStack,
    Text,
    Input,
    Icon,
    Flex,
    Image,
    Heading,
    Textarea,
    Spinner,
    Select,
    Tooltip,
} from '@chakra-ui/react';
import { FiEdit2 } from 'react-icons/fi';
import { FaImage, FaTimes, FaUserAlt } from 'react-icons/fa';
import ppt from '../../../public/icons/ppt.svg';
import mp4 from '../../../public/icons/mp4.svg';
import Page from '../../survey/assets/Page';
import { useNavigate } from 'react-router-dom';
import BrandButton from '../../../components/brandButton/BrandButton';

const CompanyProile = ({
    images,
    isOpenEditSurvey,
    addCompanyModalIsOpen,
    viewProfileAsOthers,
    accountType,
    editSurvey,
    currentCompanyIndex,
    onChangeCurrentCompanyIndex,
    allCompaniesInfo,
    isDesktop,
    companyDetails,
    closeEditSurvey,
    isCompanyFormIncomplete,
    submitCompanydata,
    isLoading,
    filledData,
    setFilledData,
    surveyData,
    handleChange,
    imageSource,
    handleChangeForImages,
    imagesInputRef,
    openImageUpload,
    uploadExtraImages,
    isLoadingImageUpload,
    setImages,
    setImageSource,
    removeExtraImages,
    imageIndex,
    addCompanyData,
    setAddCompanyData,
    handleAddCompanyDataChange,
    pitchDeckRef,
    handleAddCompanyFileInput,
    problemRef,
    solutionRef,
    marketGrowthRef,
    revenueModelRef,
    competitionRef,
    fundsUseRef,
    stakeholdersRef,
    isValidUrl,
    setWebsiteUrlError,
    websiteUrlError,
    isLoadingAddExtraCompany,
    addExtraCompany,
    onCloseAddCompanyModal,
    companyStageRef,
    fundCategoryRef,
    incorporationLocationRef,
    businessModelRef,
    businessCategoryRef,
    handleFileInput,
    videoUrlRef,
    customerTypeRef,
}) => {
    const navigate = useNavigate();
    const openPDF = () => {
        if (companyDetails?.pitch_deck) {
            navigate('pdf-viewer');
        }
    };


    const openVideo = () => {
        if (companyDetails?.video_url) {
            navigate('video-viewer');
        }
    };


    return (
        <>
            {!isOpenEditSurvey && !addCompanyModalIsOpen ? (
                <>
                    <Tooltip label="See how your profile appears to other users">
                        <Button
                            leftIcon={<Icon as={FaUserAlt} />}
                            borderRadius={4}
                            color="brand.primary"
                            bgColor="#fff"
                            fontSize="14px"
                            px={4}
                            border="1px solid"
                            borderColor="brand.primary"
                            type="submit"
                            w={'full'}
                            className="mt-4"
                            _hover={{ background: 'rgba(0, 0, 0, 0.05s)' }}
                            onClick={viewProfileAsOthers}
                        >
                            View Profile
                        </Button>
                    </Tooltip>
                    <Button
                        leftIcon={<Icon as={FiEdit2} />}
                        borderRadius={4}
                        color="#fff"
                        bgColor="brand.primary"
                        fontSize="14px"
                        px={4}
                        type="submit"
                        w={'full'}
                        className="my-4"
                        _hover={{ background: 'brand.primary' }}
                        onClick={editSurvey}
                    >
                        Edit Profile
                    </Button>
                    <Box className="border flex flex-col rounded-lg p-4">
                        <Flex
                            className={`${accountType === 'founder' ? 'flex-col-reverse md:justify-between' : 'justify-start'} gap-1 items-start md:items-center `}
                        >
                            <Box
                                className={`flex md:hidden flex-col gap-1 mb-4 md:mb-0`}
                            >
                                <Select
                                    className="w-[220px]"
                                    value={currentCompanyIndex}
                                    onChange={onChangeCurrentCompanyIndex}
                                    placeholder={''}
                                >
                                    {allCompaniesInfo.map((_company, index) => (
                                        <option key={index} value={index}>
                                            {_company.title}
                                        </option>
                                    ))}
                                </Select>
                            </Box>
                            <Text className="text-lg text-[#2F4B6E] font-medium">
                                Business Overview
                            </Text>
                        </Flex>

                        <Box>
                            <Flex className="flex flex-wrap lg:flex-nowrap w-full gap-1 mb-4">
                                <Text
                                    className="md:w-[50%] xl:w-[240px]"
                                    fontWeight={500}
                                    color="#C0BCBC"
                                >
                                    {isDesktop ? `Company Name` : `Name`}:
                                </Text>
                                <Box className="md:w-[50%] xl:w-full">
                                    <Text color="#000">
                                        {companyDetails?.title}
                                    </Text>
                                </Box>
                            </Flex>
                            {accountType === 'investor' ? (
                                <Flex className="flex flex-wrap lg:flex-nowrap w-full gap-1 mb-4">
                                    <Text
                                        className="md:w-[50%] xl:w-[240px]"
                                        fontWeight={500}
                                        color="#C0BCBC"
                                    >
                                        Job Title:
                                    </Text>
                                    <Box className="md:w-[50%] xl:w-full">
                                        <Text color="#000">
                                            {companyDetails?.job_title}
                                        </Text>
                                    </Box>
                                </Flex>
                            ) : null}
                            <Flex className="flex flex-wrap lg:flex-nowrap w-full gap-1 mb-4">
                                <Text
                                    fontWeight={500}
                                    color="#C0BCBC"
                                    className="no-wrap w-max md:w-[50%] xl:w-[240px]"
                                >
                                    {isDesktop ? `Company Stage` : `Stage`}:
                                </Text>
                                <Box className="md:w-[50%] xl:w-full">
                                    {companyDetails?.company_stage?.map(
                                        ({ title }, index) => (
                                            <Text key={index}>
                                                {title}
                                                <br />
                                            </Text>
                                        ),
                                    )}
                                </Box>
                            </Flex>
                            <Flex className="flex flex-wrap lg:flex-nowrap w-full gap-1 mb-4">
                                <Text
                                    fontWeight={500}
                                    color="#C0BCBC"
                                    className="no-wrap w-max md:w-[50%] xl:w-[240px]"
                                >
                                    Kind of fund:
                                </Text>
                                <Box className="md:w-[50%] xl:w-full">
                                    <Text color="#000">
                                        {companyDetails?.fund_category?.title}
                                    </Text>
                                </Box>
                            </Flex>
                            {accountType === 'investor' ? (
                                <Flex className="flex flex-wrap lg:flex-nowrap w-full gap-1 mb-4">
                                    <Text
                                        fontWeight={500}
                                        color="#C0BCBC"
                                        className="no-wrap w-max md:w-[50%] xl:w-[240px]"
                                    >
                                        Investment locations:
                                    </Text>
                                    <Box className="md:w-[50%] xl:w-full">
                                        {companyDetails?.investment_location?.map(
                                            ({ name }) => (
                                                <Text>{name}</Text>
                                            ),
                                        )}
                                    </Box>
                                </Flex>
                            ) : null}
                            <Flex className="flex flex-wrap lg:flex-nowrap w-full gap-1 mb-4">
                                <Text
                                    fontWeight={500}
                                    color="#C0BCBC"
                                    className="no-wrap w-max md:w-[50%] xl:w-[240px]"
                                >
                                    {isDesktop
                                        ? `Location of company`
                                        : `Locations`}
                                    :
                                </Text>
                                <Box className="md:w-[50%] xl:w-full">
                                    {companyDetails?.incorporation_location?.map(
                                        ({ name }, index) => (
                                            <Text key={index}>{name}</Text>
                                        ),
                                    )}
                                </Box>
                            </Flex>
                            <Flex className="flex flex-wrap lg:flex-nowrap w-full gap-1 mb-4">
                                <Text
                                    className="no-wrap w-max md:w-[50%] xl:w-[240px]"
                                    fontWeight={500}
                                    color="#C0BCBC"
                                >
                                    Business model:
                                </Text>
                                <Box className="md:w-[50%] xl:w-full">
                                    {companyDetails?.business_model?.map(
                                        ({ title }, index) => (
                                            <Text key={index}>{title}</Text>
                                        ),
                                    )}
                                </Box>
                            </Flex>
                            <Flex className="flex flex-wrap lg:flex-nowrap w-full gap-1 mb-4">
                                <Text
                                    fontWeight={500}
                                    color="#C0BCBC"
                                    className="no-wrap w-max md:w-[50%] xl:w-[240px]"
                                >
                                    Category:
                                </Text>
                                <Box className="md:w-[50%] xl:w-full">
                                    {companyDetails?.business_category?.map(
                                        ({ title }, index) => (
                                            <Text key={index}>{title}</Text>
                                        ),
                                    )}
                                </Box>
                            </Flex>
                            {accountType === 'founder' ? (
                                <Flex className="flex flex-wrap lg:flex-nowrap w-full gap-1 mb-4">
                                    <Text
                                        fontWeight={500}
                                        color="#C0BCBC"
                                        className="no-wrap w-max md:w-[50%] xl:w-[240px]"
                                    >
                                        Valuation:
                                    </Text>
                                    <Box className="md:w-[50%] xl:w-full">
                                        <Text>{companyDetails?.valuation}</Text>
                                    </Box>
                                </Flex>
                            ) : null}
                            {accountType === 'founder' ? (
                                <Flex className="flex flex-wrap lg:flex-nowrap w-full gap-1 mb-4">
                                    <Text
                                        fontWeight={500}
                                        color="#C0BCBC"
                                        className="no-wrap w-max md:w-[50%] xl:w-[240px]"
                                    >
                                        Funding Target:
                                    </Text>
                                    <Box className="md:w-[50%] xl:w-full">
                                        <Text>{companyDetails?.funding_target}</Text>
                                    </Box>
                                </Flex>
                            ) : null}
                            {accountType === 'founder' ? (
                                <Flex className="flex flex-wrap lg:flex-nowrap w-full gap-1 mb-4">
                                    <Text
                                        fontWeight={500}
                                        color="#C0BCBC"
                                        className="no-wrap w-max md:w-[50%] xl:w-[240px]"
                                    >
                                        Number of Investors:
                                    </Text>
                                    <Box className="md:w-[50%] xl:w-full">
                                        <Text>
                                            {companyDetails?.number_of_investors}
                                        </Text>
                                    </Box>
                                </Flex>
                            ) : null}
                            {accountType === 'founder' && (
                                <HStack
                                    spacing={12}
                                    h={{ base: '4vh', '2xl': '6.7vh' }}
                                    className="mb-4"
                                >
                                    <Text fontWeight={500} color="#9FA7AD">
                                        File(s)
                                    </Text>
                                    <HStack spacing={6}>
                                        {/* <a href={companyDetails?.pitch_deck} target="_blank" rel="noreferrer"> */}
                                        <Image
                                            src={ppt}
                                            boxSize={isDesktop ? '30px' : '25px'}
                                            cursor="pointer"
                                            onClick={() => openPDF()}
                                        />
                                        {/* </a> */}
                                        <Image
                                            src={mp4}
                                            boxSize={isDesktop ? '30px' : '25px'}
                                            cursor="pointer"
                                            onClick={() => openVideo()}
                                        />
                                    </HStack>
                                </HStack>
                            )}
                        </Box>

                        <Flex className="flex flex-wrap lg:flex-nowrap w-full gap-1 mb-4">
                            <Text
                                color="#C0BCBC"
                                fontWeight={500}
                                className="no-wrap w-max md:w-[50%] xl:w-[240px]"
                            >
                                Description:
                            </Text>
                            <Box className="md:w-[50%] xl:w-full">
                                <Text color="#000">
                                    {companyDetails?.description}
                                </Text>
                            </Box>
                        </Flex>

                        {accountType === 'founder' ? (
                            <Box className="mt-8">
                                <Text
                                    color="brand.primary"
                                    className="text-md font-bold"
                                >
                                    Additional Images
                                </Text>
                                <Text className="my-2">
                                    {`Media slots left: ${8 - (companyDetails?.additional_images?.length || 0) - (imageSource?.length || 0)}`}
                                </Text>
                                <>
                                    {images?.length > 0 ? (
                                        <Box className="flex my-5 flex-col gap-5">
                                            <Box className="flex items-center flex-wrap gap-3">
                                                {imageSource.map((image, index) => (
                                                    <Image
                                                        key={index}
                                                        src={image}
                                                        className={
                                                            'h-[165px] w-[165px] object-contain'
                                                        }
                                                    />
                                                ))}
                                                <Input
                                                    accept="image/*"
                                                    id="image-attachments"
                                                    type="file"
                                                    onChange={(e) =>
                                                        handleChangeForImages(e)
                                                    }
                                                    name="attachments"
                                                    key="image-attachments"
                                                    hidden
                                                    multiple
                                                    ref={imagesInputRef}
                                                />
                                                {images ? null : (
                                                    <Box className="flex flex-wrap gap-2 ">
                                                        <Box
                                                            onClick={openImageUpload}
                                                            className="p-3 h-[130px] w-[140px] flex flex-col items-center justify-center rounded border border-dashed cursor-pointer"
                                                        >
                                                            <FaImage fontSize={'xl'} />
                                                            <Text className="text-[10px] text-center">
                                                                Click to upload image
                                                            </Text>
                                                        </Box>
                                                    </Box>
                                                )}

                                                <Button
                                                    bgColor="brand.primary"
                                                    color="#fff"
                                                    borderRadius={4}
                                                    px={4}
                                                    _hover={{ background: 'brand.primary' }}
                                                    onClick={uploadExtraImages}
                                                    className="w-full mx-auto"
                                                >
                                                    {isLoadingImageUpload ? (
                                                        <Flex>
                                                            <Spinner />
                                                        </Flex>
                                                    ) : (
                                                        `Upload ${imageSource?.length > 1 ? 'images' : 'image'}`
                                                    )}
                                                </Button>

                                                <Button
                                                    bgColor="red.500"
                                                    color="#fff"
                                                    borderRadius={4}
                                                    px={4}
                                                    _hover={{ background: 'red.500' }}
                                                    onClick={() => {
                                                        setImages(null);
                                                        setImageSource([]);
                                                    }}
                                                    className="w-full mx-auto"
                                                >
                                                    Clear selection
                                                </Button>
                                            </Box>
                                        </Box>
                                    ) : (
                                        <Box className="flex flex-wrap items-center justify-center md:justify-start my-5 gap-3">
                                            {companyDetails?.additional_images?.length >
                                                0 ? (
                                                companyDetails?.additional_images?.map(
                                                    (image, index) => {
                                                        return (
                                                            <Box
                                                                key={index}
                                                                className="relative"
                                                            >
                                                                <Text
                                                                    onClick={() =>
                                                                        removeExtraImages(index)
                                                                    }
                                                                    className={`text-xs absolute rounded-full font-medium right-[-5px] top-[-7px] bg-white border border-black text-gray-900 p-2 cursor-pointer`}
                                                                >
                                                                    <FaTimes />
                                                                </Text>
                                                                {index == imageIndex ? (
                                                                    <Flex className="absolute w-full justify-center top-[40%]">
                                                                        <Spinner />
                                                                    </Flex>
                                                                ) : null}
                                                                <Image
                                                                    src={image}
                                                                    className={
                                                                        'h-[165px] object-contain w-[165px]'
                                                                    }
                                                                />
                                                            </Box>
                                                        );
                                                    },
                                                )
                                            ) : (
                                                <Text className="flex items-center p-3 text-gray-500 font-semibold">
                                                    Click the button to add media
                                                </Text>
                                            )}
                                            <Input
                                                accept="image/*"
                                                id="image-attachments"
                                                type="file"
                                                onChange={(e) => handleChangeForImages(e)}
                                                name="attachments"
                                                key="image-attachments"
                                                hidden
                                                multiple
                                                ref={imagesInputRef}
                                            />
                                            <Box className="flex flex-wrap gap-2 ">
                                                <Box
                                                    onClick={openImageUpload}
                                                    className="p-3 h-[130px] w-[140px] flex flex-col items-center justify-center rounded border border-dashed cursor-pointer"
                                                >
                                                    <FaImage fontSize={'xl'} />
                                                    <Text className="text-[10px] text-center">
                                                        Click to upload image
                                                    </Text>
                                                </Box>
                                            </Box>
                                        </Box>
                                    )}
                                </>
                            </Box>
                        ) : null}
                    </Box>
                </>
            ) : addCompanyModalIsOpen ? (
                <Flex className="flex-col">
                    <Box className="p-4">
                        <Heading fontSize="24px" color="brand.primary" mb={4}>
                            Add Company
                        </Heading>
                        <Box className={`flex flex-col gap-2 mb-3`}>
                            <Text
                                fontWeight={500}
                                fontSize="16px"
                                color="#000"
                                className="mb-2"
                            >
                                Enter your company's name?
                                {!addCompanyData?.title && (
                                    <Text className="text-red-600 text-lg inline font-bold">
                                        *
                                    </Text>
                                )}
                            </Text>
                            <Input
                                key="title"
                                type="text"
                                placeholder="Type here...."
                                name="title"
                                borderRadius="10px"
                                borderWidth={1}
                                borderColor="brand.primary"
                                h="50px"
                                defaultValue={addCompanyData.title}
                                className="mb-3.5"
                                onChange={(e) => handleAddCompanyDataChange(e)}
                            />
                            <Text
                                fontWeight={500}
                                fontSize="16px"
                                color="#000"
                                className="mb-2"
                            >
                                Describe your company in few words{' '}
                                {!addCompanyData?.description && (
                                    <Text className="text-red-600 text-lg inline font-bold">
                                        *
                                    </Text>
                                )}
                            </Text>
                            <Textarea
                                key="description"
                                placeholder="Type here...."
                                type="text"
                                name="description"
                                borderRadius="10px"
                                borderWidth={1}
                                borderColor="brand.primary"
                                minH="150px"
                                className="mb-3.5"
                                defaultValue={addCompanyData.description}
                                onChange={(e) => handleAddCompanyDataChange(e)}
                            />
                        </Box>
                        <Box>
                            <Page
                                question="What is your start-up stage?"
                                options={surveyData?.companyStages || []}
                                data={{ companyStageId: undefined }}
                                setFilledData={setAddCompanyData}
                                filledData={addCompanyData}
                                responseId={addCompanyData?.companyStageId}
                                pageContainerClasses={
                                    'w-full items-start justify-start place-self-start justify-self-start '
                                }
                                isOnboardingView={false}
                            />
                        </Box>
                        <Box>
                            <Page
                                question="What type of funding does your start-up require?"
                                options={surveyData?.fundCategories || []}
                                data={{ fundCategoryId: undefined }}
                                setFilledData={setAddCompanyData}
                                filledData={addCompanyData}
                                responseId={addCompanyData?.fundCategoryId}
                                pageContainerClasses={'w-full items-start'}
                                isOnboardingView={false}
                            />
                        </Box>
                        <Box>
                            <Page
                                question="Where is your start-up incorporated?"
                                isCheckBox={true}
                                options={surveyData?.locations || []}
                                data={{ incorporationLocationId: undefined }}
                                setFilledData={setAddCompanyData}
                                filledData={addCompanyData}
                                responseId={
                                    addCompanyData?.incorporationLocationId
                                }
                                pageContainerClasses={'w-full items-start'}
                                isOnboardingView={false}
                            />
                        </Box>
                        <Box>
                            <Page
                                question="Which business model best describes your start-up?"
                                options={surveyData?.businessModels || []}
                                data={{ businessModelId: undefined }}
                                setFilledData={setAddCompanyData}
                                filledData={addCompanyData}
                                responseId={addCompanyData?.businessModelId}
                                pageContainerClasses={'w-full items-start'}
                                isOnboardingView={false}
                            />
                        </Box>
                        <Box>
                            <Page
                                question="Which category best describes your start-up?"
                                options={surveyData?.categories || []}
                                data={{ businessCategoryId: undefined }}
                                setFilledData={setAddCompanyData}
                                filledData={addCompanyData}
                                responseId={addCompanyData?.businessCategoryId}
                                pageContainerClasses={'w-full items-start'}
                                isOnboardingView={false}
                            />
                        </Box>
                        <Box className="flex flex-col w-full gap-2.5">
                            <Text fontWeight={500} fontSize="16px" color="#000">
                                Current Valuation{' '}
                                {!addCompanyData?.valuation && (
                                    <Text className="text-red-600 text-lg inline font-bold">
                                        *
                                    </Text>
                                )}
                            </Text>
                            <Input
                                key="valuation"
                                type="number"
                                placeholder="Type here...."
                                defaultValue={Number(
                                    addCompanyData?.valuation || 0,
                                )}
                                name="valuation"
                                borderRadius="10px"
                                borderWidth={2}
                                // borderColor={
                                //   !addCompanyData?.valuation
                                //     ? 'red.500'
                                //     : 'brand.primary'
                                // }
                                min={0}
                                h="50px"
                                onChange={(e) => handleAddCompanyDataChange(e)}
                                mb={2}
                            />
                        </Box>
                        <Box className="flex flex-col w-full gap-2.5">
                            <Text fontWeight={500} fontSize="16px" color="#000">
                                Funding Target{' '}
                                {!addCompanyData?.funding_target && (
                                    <Text className="text-red-600 text-lg inline font-bold">
                                        *
                                    </Text>
                                )}
                            </Text>
                            <Input
                                key="funding_target"
                                type="number"
                                placeholder="Type here...."
                                name="funding_target"
                                borderRadius="10px"
                                borderWidth={2}
                                defaultValue={Number(
                                    addCompanyData?.fundCategoryId || 0,
                                )}
                                min={0}
                                // borderColor={
                                //   !addCompanyData?.funding_target
                                //     ? 'red.500'
                                //     : 'brand.primary'
                                // }
                                h="50px"
                                onChange={(e) => handleAddCompanyDataChange(e)}
                                mb={2}
                            />
                        </Box>
                        <Box className="flex flex-col w-full gap-2.5">
                            <Text fontWeight={500} fontSize="16px" color="#000">
                                Current Number of Investors on Cap Table{' '}
                                {!addCompanyData?.number_of_investors && (
                                    <Text className="text-red-600 text-lg inline font-bold">
                                        *
                                    </Text>
                                )}
                            </Text>
                            <Input
                                key="number_of_investors"
                                type="number"
                                placeholder="Type here...."
                                defaultValue={Number(
                                    addCompanyData?.number_of_investors || 0,
                                )}
                                name="number_of_investors"
                                borderRadius="10px"
                                min={0}
                                borderWidth={2}
                                // borderColor={
                                //   !addCompanyData?.number_of_investors
                                //     ? 'red.500'
                                //     : 'brand.primary'
                                // }
                                h="50px"
                                onChange={(e) => handleAddCompanyDataChange(e)}
                                mb={2}
                            />
                        </Box>
                        <Box>
                            <Text
                                fontWeight={500}
                                fontSize="16px"
                                color="#000"
                                ref={pitchDeckRef}
                            >
                                Upload pitch-deck{' '}
                                {!addCompanyData?.pitch_deck && (
                                    <Text className="text-red-600 text-lg inline font-bold">
                                        *
                                    </Text>
                                )}
                            </Text>
                            <Input
                                hidden
                                id="file-input-btn"
                                key="pitch_deck"
                                accept="application/pdf"
                                onChange={handleAddCompanyFileInput}
                                type="file"
                                placeholder="Type here...."
                                name="pitch_deck"
                                borderRadius="10px"
                                borderWidth={1}
                                borderColor="brand.primary"
                                h="50px"
                            />
                            <Flex
                                alignItems="center"
                                justifyContent="flex-start"
                                w="100%"
                            >
                                <label h="100%" htmlFor="file-input-btn">
                                    <Flex
                                        w="100px"
                                        cursor="pointer"
                                        borderRadius="5px"
                                        _active={{ backgroundColor: 'lightgray' }}
                                        justifyContent="center"
                                        alignItems="center"
                                        h="50px"
                                        bg="brand.primary"
                                        fontWeight="600"
                                        fontSize="16px"
                                        className="mb-4 mt-3"
                                    >
                                        <Text color="white" fontSize="14px">
                                            Browse File
                                        </Text>
                                    </Flex>
                                </label>
                                <Box w="70%">
                                    <Text ml={2}>
                                        {addCompanyData?.pitch_deck?.name || ''}
                                    </Text>
                                </Box>
                            </Flex>
                            <Text
                                fontWeight={500}
                                fontSize="16px"
                                color="#000"
                                ref={pitchDeckRef}
                                className="mt-4 mb-3"
                            >
                                Add Video url{' '}
                                {!addCompanyData?.video_url && (
                                    <Text className="text-red-600 text-lg inline font-bold">
                                        *
                                    </Text>
                                )}
                            </Text>
                            <Input
                                key="video-url"
                                type="text"
                                placeholder="Type here...."
                                className="mb-4"
                                defaultValue={addCompanyData?.video_url}
                                name="video_url"
                                borderRadius="10px"
                                borderWidth={1}
                                borderColor="brand.primary"
                                h="50px"
                                onChange={(e) => handleAddCompanyDataChange(e)}
                            />
                        </Box>

                        <Box className="w-full">
                            <Text
                                fontWeight={500}
                                fontSize="16px"
                                color="#000"
                                ref={pitchDeckRef}
                                className="mt-4 mb-3"
                            >
                                Add Social Media URL{' '}
                                {!addCompanyData?.social_media_url && (
                                    <Text className="text-red-600 text-lg inline font-bold">
                                        *
                                    </Text>
                                )}
                            </Text>
                            <Input
                                key="social_media_url"
                                type="text"
                                placeholder="Type here...."
                                className="mb-4"
                                defaultValue={addCompanyData?.social_media_url}
                                name="social_media_url"
                                borderRadius="10px"
                                borderWidth={1}
                                borderColor="brand.primary"
                                h="50px"
                                onChange={(e) => handleAddCompanyDataChange(e)}
                            />
                        </Box>

                        <Flex className="gap-2 flex-col my-3">
                            <Text
                                fontWeight={500}
                                fontSize="16px"
                                color="#000"
                                className="mb-1"
                            >
                                Problem{' '}
                                {!addCompanyData?.problem && (
                                    <Text className="text-red-600 text-lg inline font-bold">
                                        *
                                    </Text>
                                )}
                            </Text>
                            <Textarea
                                name="problem"
                                value={addCompanyData?.problem}
                                onChange={handleAddCompanyDataChange}
                                maxLength={300}
                                rows={4}
                                borderRadius="10px"
                                className="mb-4"
                                borderWidth={1}
                                borderColor="brand.primary"
                                placeholder="Describe the specific problem your startup aims to solve or the market gap it addresses"
                            />
                            <Text
                                fontWeight={500}
                                fontSize="16px"
                                color="#000"
                                ref={problemRef}
                                className="mb-1"
                            >
                                Solution{' '}
                                {!addCompanyData?.solution && (
                                    <Text className="text-red-600 text-lg inline font-bold">
                                        *
                                    </Text>
                                )}
                            </Text>
                            <Textarea
                                name="solution"
                                value={addCompanyData?.solution}
                                onChange={handleAddCompanyDataChange}
                                maxLength={300}
                                rows={4}
                                borderRadius="10px"
                                borderWidth={1}
                                borderColor="brand.primary"
                                placeholder="Outline how your idea solves the problem"
                            />
                            <Text
                                fontWeight={500}
                                fontSize="16px"
                                color="#000"
                                ref={solutionRef}
                                className="mb-1"
                            >
                                Market Growth{' '}
                                {!addCompanyData?.market_growth && (
                                    <Text className="text-red-600 text-lg inline font-bold">
                                        *
                                    </Text>
                                )}
                            </Text>
                            <Textarea
                                name="market_growth"
                                value={addCompanyData?.market_growth}
                                onChange={handleAddCompanyDataChange}
                                maxLength={300}
                                rows={4}
                                borderRadius="10px"
                                className="mb-4"
                                borderWidth={1}
                                borderColor="brand.primary"
                                placeholder={`Insights into the target market's growth potential`}
                            />
                            <Text
                                fontWeight={500}
                                fontSize="16px"
                                color="#000"
                                ref={marketGrowthRef}
                                className="mb-1"
                            >
                                Business Model{' '}
                                {!addCompanyData?.revenue_model && (
                                    <Text className="text-red-600 text-lg inline font-bold">
                                        *
                                    </Text>
                                )}
                            </Text>
                            <Textarea
                                name="revenue_model"
                                value={addCompanyData?.revenue_model}
                                onChange={handleAddCompanyDataChange}
                                maxLength={300}
                                rows={4}
                                borderRadius="10px"
                                borderWidth={1}
                                borderColor="brand.primary"
                                className="mb-4"
                                placeholder={`outline your startup's revenue generation strategy or business model`}
                            />
                            <Text
                                fontWeight={500}
                                fontSize="16px"
                                color="#000"
                                ref={revenueModelRef}
                                className="mb-1"
                            >
                                Competition{' '}
                                {!addCompanyData?.competition && (
                                    <Text className="text-red-600 text-lg inline font-bold">
                                        *
                                    </Text>
                                )}
                            </Text>
                            <Textarea
                                name="competition"
                                value={addCompanyData?.competition}
                                onChange={handleAddCompanyDataChange}
                                maxLength={300}
                                rows={4}
                                borderRadius="10px"
                                borderWidth={1}
                                borderColor="brand.primary"
                                className="mb-4"
                                placeholder={`List your competitors and how the startup differentiates from them`}
                            />
                            <Text
                                fontWeight={500}
                                fontSize="16px"
                                color="#000"
                                ref={competitionRef}
                                className="mb-1"
                            >
                                Use of funds{' '}
                                {!addCompanyData?.fund_use && (
                                    <Text className="text-red-600 text-lg inline font-bold">
                                        *
                                    </Text>
                                )}
                            </Text>
                            <Textarea
                                name="fund_use"
                                value={addCompanyData?.fund_use}
                                onChange={handleAddCompanyDataChange}
                                maxLength={300}
                                rows={4}
                                borderRadius="10px"
                                borderWidth={1}
                                borderColor="brand.primary"
                                className="mb-4"
                                placeholder={`Specify how you plan to allocate funds to various aspects of your startup`}
                            />
                            <Text
                                fontWeight={500}
                                fontSize="16px"
                                ccolor="#000"
                                ref={fundsUseRef}
                                className="mb-1"
                            >
                                Current Investors{' '}
                                {!addCompanyData?.stakeholders && (
                                    <Text className="text-red-600 text-lg inline font-bold">
                                        *
                                    </Text>
                                )}
                            </Text>
                            <Textarea
                                name="stakeholders"
                                value={addCompanyData?.stakeholders}
                                onChange={handleAddCompanyDataChange}
                                maxLength={300}
                                rows={4}
                                borderRadius="10px"
                                borderWidth={1}
                                borderColor="brand.primary"
                                className="mb-4"
                                placeholder={`If applicable, provide information about current investors or stakeholders`}
                            />
                            <Text
                                fontWeight={500}
                                fontSize="16px"
                                color="#000"
                                ref={stakeholdersRef}
                                className="mb-1"
                            >
                                Customers{' '}
                                {!addCompanyData?.customer_type && (
                                    <Text className="text-red-600 text-lg inline font-bold">
                                        *
                                    </Text>
                                )}
                            </Text>
                            <Textarea
                                name="customer_type"
                                value={addCompanyData?.customer_type}
                                onChange={handleAddCompanyDataChange}
                                maxLength={300}
                                rows={4}
                                borderRadius="10px"
                                borderWidth={1}
                                borderColor="brand.primary"
                                className="mb-4"
                                placeholder={`Details about the target customer base are essential`}
                            />
                        </Flex>

                        <Box className="w-full">
                            <Text fontWeight={500} fontSize="16px" color="#000">
                                Website URL{' '}
                                {!filledData?.website_url && (
                                    <Text className="text-red-600 text-lg inline font-bold">
                                        *
                                    </Text>
                                )}
                            </Text>
                            <Input
                                key="website_url"
                                type="url"
                                placeholder="https://example.com"
                                name="website_url"
                                value={filledData?.website_url}
                                onChange={handleChange}
                                onBlur={(e) => {
                                    const value = e.target.value;
                                    if (value && !isValidUrl(value)) {
                                        setWebsiteUrlError(
                                            'Please enter a valid URL starting with https://',
                                        );
                                    } else {
                                        setWebsiteUrlError('');
                                    }
                                }}
                                borderRadius="10px"
                                borderWidth={1}
                                h="50px"
                                className={`border ${websiteUrlError ? 'border-red-500' : ''}`}
                            />
                            {websiteUrlError && (
                                <Text color="red.500" fontSize="sm" mt={1}>
                                    {websiteUrlError}
                                </Text>
                            )}
                        </Box>

                        <Box
                            className="mt-7 flex flex-col md:flex-row gap-3 items-center justify-between"
                            w="full"
                        >
                            <BrandButton
                                text="Submit"
                                width="full"
                                colorScheme="blue"
                                isLoading={isLoadingAddExtraCompany}
                                onClick={addExtraCompany}
                            />
                            <BrandButton
                                text="Cancel"
                                width="full"
                                onClick={onCloseAddCompanyModal}
                            />
                        </Box>
                    </Box>
                </Flex>
            ) : (
                <Box>
                    {/* <Heading fontSize="24px" color="brand.primary" mb={4}>
          Edit {companyDetails?.title} Data
        </Heading> */}
                    <Text className="text-lg text-[#2F4B6E] px-4 mt-4 font-medium mb-4">
                        Business Overview
                    </Text>
                    <VStack
                        flexDir="column"
                        w={isDesktop ? '100%' : '100%'}
                        justifyContent="flex-start"
                        alignItems={isDesktop ? 'flex-start' : 'flex-start'}
                        className="gap-2 px-4 py-6"
                    >
                        <Text fontWeight={500} fontSize="16px" color="#000">
                            Enter your company's name?
                            {!filledData?.title && (
                                <Text className="text-red-600 text-lg inline font-bold">
                                    *
                                </Text>
                            )}
                        </Text>
                        <Input
                            key="title"
                            type="text"
                            placeholder="Type here...."
                            defaultValue={companyDetails?.title}
                            name="title"
                            borderRadius="10px"
                            borderWidth={1}
                            borderColor={
                                !filledData?.title ? 'red.500' : 'brand.primary'
                            }
                            h="50px"
                            onChange={(e) => handleChange(e)}
                        />
                        <Box className="w-full" />

                        {accountType === 'investor' ? (
                            <>
                                <Text
                                    fontWeight={500}
                                    fontSize="16px"
                                    color="#000"
                                >
                                    Enter your job title
                                    {!filledData?.job_title && (
                                        <Text className="text-red-600 text-lg inline font-bold">
                                            *
                                        </Text>
                                    )}
                                </Text>
                                <Input
                                    key="title"
                                    type="text"
                                    placeholder="Type here...."
                                    defaultValue={companyDetails?.job_title}
                                    name="job_title"
                                    borderRadius="10px"
                                    borderWidth={2}
                                    borderColor={
                                        !filledData?.job_title
                                            ? 'red.500'
                                            : 'brand.primary'
                                    }
                                    h="50px"
                                    onChange={(e) => handleChange(e)}
                                    mb={2}
                                />
                                <Box className="w-full" />
                            </>
                        ) : null}

                        <Text fontWeight={500} fontSize="16px" color="#000">
                            Describe your company in few words{' '}
                            {!filledData?.description && (
                                <Text className="text-red-600 text-lg inline font-bold">
                                    *
                                </Text>
                            )}
                        </Text>
                        <Textarea
                            key="description"
                            placeholder="Type here...."
                            defaultValue={companyDetails?.description}
                            type="text"
                            name="description"
                            borderRadius="10px"
                            borderWidth={1}
                            borderColor={
                                !filledData?.description
                                    ? 'red.500'
                                    : 'brand.primary'
                            }
                            minH="150px"
                            onChange={(e) => handleChange(e)}
                            mb={2}
                        />
                        <Box className="w-full" />

                        {accountType === 'founder' ? (
                            <>
                                <Box className="flex flex-col">
                                    <Flex
                                        className="flex-col"
                                        ref={companyStageRef}
                                    >
                                        <Page
                                            question="What is your start-up stage?"
                                            options={surveyData?.companyStages || []}
                                            data={{ companyStageId: undefined }}
                                            setFilledData={setFilledData}
                                            filledData={filledData}
                                            responseId={
                                                companyDetails?.company_stage_ids
                                                    ?.length > 0
                                                    ? companyDetails?.company_stage_ids[0]
                                                    : ''
                                            }
                                            pageContainerClasses={
                                                'w-full items-start justify-start place-self-start justify-self-start '
                                            }
                                            isOnboardingView={false}
                                        />
                                    </Flex>
                                    <Flex
                                        className="flex-col"
                                        ref={fundCategoryRef}
                                    >
                                        <Page
                                            question="What type of funding does your start-up require?"
                                            options={surveyData?.fundCategories || []}
                                            data={{ fundCategoryId: undefined }}
                                            setFilledData={setFilledData}
                                            filledData={filledData}
                                            responseId={
                                                companyDetails?.fundCategoryId || ''
                                            }
                                            pageContainerClasses={'w-full items-start'}
                                            isOnboardingView={false}
                                        />
                                    </Flex>
                                    <Flex
                                        className="flex-col"
                                        ref={incorporationLocationRef}
                                    >
                                        <Page
                                            question="Where is your start-up incorporated?"
                                            isCheckBox={true}
                                            options={surveyData?.locations || []}
                                            data={{
                                                incorporationLocationId: undefined,
                                            }}
                                            setFilledData={setFilledData}
                                            filledData={filledData}
                                            responseId={companyDetails?.incorporation_location_ids.map(
                                                (item) => `${item}`,
                                            )}
                                            pageContainerClasses={'w-full items-start'}
                                            isOnboardingView={false}
                                        />
                                    </Flex>
                                    <Flex
                                        className="flex-col"
                                        ref={businessModelRef}
                                    >
                                        <Page
                                            question="Which business model best describes your start-up?"
                                            options={surveyData?.businessModels || []}
                                            data={{ businessModelId: undefined }}
                                            setFilledData={setFilledData}
                                            filledData={filledData}
                                            responseId={
                                                companyDetails?.business_model_ids
                                                    ?.length > 0
                                                    ? companyDetails?.business_model_ids[0]
                                                    : ''
                                            }
                                            pageContainerClasses={'w-full items-start'}
                                            isOnboardingView={false}
                                        />
                                    </Flex>
                                    <Flex
                                        className="flex-col"
                                        ref={businessCategoryRef}
                                    >
                                        <Page
                                            question="Which category best describes your start-up?"
                                            options={surveyData?.categories || []}
                                            data={{ businessCategoryId: undefined }}
                                            setFilledData={setFilledData}
                                            filledData={filledData}
                                            responseId={
                                                companyDetails?.business_category_ids
                                                    ?.length > 0
                                                    ? companyDetails
                                                        ?.business_category_ids[0]
                                                    : ''
                                            }
                                            pageContainerClasses={'w-full items-start'}
                                            isOnboardingView={false}
                                        />
                                    </Flex>
                                </Box>
                                <Box className="flex flex-col w-full gap-2.5">
                                    <Text
                                        fontWeight={500}
                                        fontSize="16px"
                                        color="#000"
                                    // ref={pitchDeckRef}
                                    >
                                        Current Valuation{' '}
                                        {!filledData?.valuation && (
                                            <Text className="text-red-600 text-lg inline font-bold">
                                                *
                                            </Text>
                                        )}
                                    </Text>
                                    <Input
                                        key="valuation"
                                        type="number"
                                        placeholder="Type here...."
                                        defaultValue={filledData?.valuation}
                                        name="valuation"
                                        borderRadius="10px"
                                        borderWidth={2}
                                        min={0}
                                        h="50px"
                                        onChange={(e) => handleChange(e)}
                                        mb={2}
                                    />
                                </Box>
                                <Box className="flex flex-col w-full gap-2.5">
                                    <Text
                                        fontWeight={500}
                                        fontSize="16px"
                                        color="#000"
                                    // ref={pitchDeckRef}
                                    >
                                        Funding Target{' '}
                                        {!filledData?.funding_target && (
                                            <Text className="text-red-600 text-lg inline font-bold">
                                                *
                                            </Text>
                                        )}
                                    </Text>
                                    <Input
                                        key="funding_target"
                                        type="number"
                                        placeholder="Type here...."
                                        defaultValue={filledData?.funding_target}
                                        name="funding_target"
                                        borderRadius="10px"
                                        borderWidth={2}
                                        min={0}
                                        h="50px"
                                        onChange={(e) => handleChange(e)}
                                        mb={2}
                                    />
                                </Box>
                                <Box className="flex flex-col w-full gap-2.5">
                                    <Text
                                        fontWeight={500}
                                        fontSize="16px"
                                        color="#000"
                                    // ref={pitchDeckRef}
                                    >
                                        Current Number of Investors on Cap Table{' '}
                                        {!filledData?.number_of_investors && (
                                            <Text className="text-red-600 text-lg inline font-bold">
                                                *
                                            </Text>
                                        )}
                                    </Text>
                                    <Input
                                        key="number_of_investors"
                                        type="number"
                                        placeholder="Type here...."
                                        defaultValue={filledData?.number_of_investors}
                                        name="number_of_investors"
                                        borderRadius="10px"
                                        borderWidth={2}
                                        min={0}
                                        h="50px"
                                        onChange={(e) => handleChange(e)}
                                        mb={2}
                                    />
                                </Box>
                                <Text
                                    fontWeight={500}
                                    fontSize="16px"
                                    color="#000"
                                    ref={pitchDeckRef}
                                >
                                    Upload pitch-deck{' '}
                                    {!filledData?.pitch_deck && (
                                        <Text className="text-red-600 text-lg inline font-bold">
                                            *
                                        </Text>
                                    )}
                                </Text>
                                <Input
                                    hidden
                                    id="file-input-btn"
                                    key="pitch_deck"
                                    accept="application/pdf"
                                    onChange={handleFileInput}
                                    type="file"
                                    placeholder="Type here...."
                                    name="pitch_deck"
                                    borderRadius="10px"
                                    borderWidth={1}
                                    borderColor="brand.primary"
                                    h="50px"
                                />
                                <Flex
                                    alignItems="center"
                                    justifyContent="flex-start"
                                    w="100%"
                                >
                                    <label h="100%" htmlFor="file-input-btn">
                                        <Flex
                                            w="100px"
                                            cursor="pointer"
                                            borderRadius="5px"
                                            _active={{ backgroundColor: 'lightgray' }}
                                            justifyContent="center"
                                            alignItems="center"
                                            h="50px"
                                            bg="brand.primary"
                                            fontWeight="600"
                                            fontSize="16px"
                                        >
                                            <Text color="white" fontSize="14px">
                                                Browse File
                                            </Text>
                                        </Flex>
                                    </label>
                                    <Box w="70%">
                                        <Text ml={2}>
                                            {
                                                (
                                                    filledData?.pitch_deck?.name ||
                                                    companyDetails?.pitch_deck ||
                                                    ''
                                                )
                                                    .split('/')
                                                    .reverse()[0]
                                            }
                                        </Text>
                                    </Box>
                                </Flex>
                                <Text
                                    fontWeight={500}
                                    fontSize="16px"
                                    color="#000"
                                    ref={pitchDeckRef}
                                >
                                    Add Video url{' '}
                                    {!filledData?.video_url && (
                                        <Text className="text-red-600 text-lg inline font-bold">
                                            *
                                        </Text>
                                    )}
                                </Text>
                                <Input
                                    key="video-url"
                                    type="text"
                                    placeholder="Type here...."
                                    defaultValue={filledData?.video_url}
                                    name="video_url"
                                    borderRadius="10px"
                                    borderWidth={1}
                                    borderColor="brand.primary"
                                    h="50px"
                                    onChange={(e) => handleChange(e)}
                                />

                                <Box className="w-full">
                                    <Text
                                        fontWeight={500}
                                        fontSize="16px"
                                        color="#000"
                                        ref={pitchDeckRef}
                                        className="mt-4 mb-3"
                                    >
                                        Add Social Media URL{' '}
                                        {!filledData?.social_media_url && (
                                            <Text className="text-red-600 text-lg inline font-bold">
                                                *
                                            </Text>
                                        )}
                                    </Text>
                                    <Input
                                        key="social_media_url"
                                        type="text"
                                        placeholder="Type here...."
                                        className="mb-4"
                                        defaultValue={filledData?.social_media_url}
                                        name="social_media_url"
                                        borderRadius="10px"
                                        borderWidth={1}
                                        borderColor="brand.primary"
                                        h="50px"
                                        onChange={(e) => handleChange(e)}
                                    />
                                </Box>

                                <Text
                                    fontWeight={500}
                                    fontSize="16px"
                                    color="#000"
                                    ref={videoUrlRef}
                                >
                                    Problem{' '}
                                    {!filledData?.problem && (
                                        <Text className="text-red-600 text-lg inline font-bold">
                                            *
                                        </Text>
                                    )}
                                </Text>
                                <Textarea
                                    name="problem"
                                    defaultValue={filledData?.problem}
                                    // value={filledData?.problem}
                                    onChange={handleChange}
                                    maxLength={300}
                                    rows={4}
                                    borderRadius="10px"
                                    borderWidth={1}
                                    className={`border ${!filledData?.problem ? 'border-red-500' : ''} `}
                                    borderColor={'brand.primary'}
                                    placeholder="Describe the specific problem your startup aims to solve or the market gap it addresses"
                                />
                                <Text
                                    fontWeight={500}
                                    fontSize="16px"
                                    color="#000"
                                    ref={problemRef}
                                >
                                    Solution{' '}
                                    {!filledData?.solution && (
                                        <Text className="text-red-600 text-lg inline font-bold">
                                            *
                                        </Text>
                                    )}
                                </Text>
                                <Textarea
                                    name="solution"
                                    defaultValue={filledData?.solution}
                                    // value={filledData?.solution}
                                    onChange={handleChange}
                                    maxLength={300}
                                    rows={4}
                                    borderRadius="10px"
                                    borderWidth={1}
                                    className={`border ${!filledData?.solution ? 'border-red-500' : ''} `}
                                    borderColor="brand.primary"
                                    placeholder="Outline how your idea solves the problem"
                                />
                                <Text
                                    fontWeight={500}
                                    fontSize="16px"
                                    color="#000"
                                    ref={solutionRef}
                                >
                                    Market Growth{' '}
                                    {!filledData?.market_growth && (
                                        <Text className="text-red-600 text-lg inline font-bold">
                                            *
                                        </Text>
                                    )}
                                </Text>
                                <Textarea
                                    name="market_growth"
                                    defaultValue={filledData?.market_growth}
                                    // value={filledData?.market_growth}
                                    onChange={handleChange}
                                    maxLength={300}
                                    rows={4}
                                    borderRadius="10px"
                                    borderWidth={1}
                                    className={`border ${!filledData?.market_growth ? 'border-red-500' : ''} `}
                                    borderColor="brand.primary"
                                    placeholder={`Insights into the target market's growth potential`}
                                />
                                <Text
                                    fontWeight={500}
                                    fontSize="16px"
                                    color="brand.primary"
                                    ref={marketGrowthRef}
                                >
                                    Business Model{' '}
                                    {!filledData?.revenue_model && (
                                        <Text className="text-red-600 text-lg inline font-bold">
                                            *
                                        </Text>
                                    )}
                                </Text>
                                <Textarea
                                    name="revenue_model"
                                    defaultValue={filledData?.revenue_model}
                                    // value={filledData?.revenue_model}
                                    onChange={handleChange}
                                    maxLength={300}
                                    rows={4}
                                    borderRadius="10px"
                                    borderWidth={1}
                                    className={`border ${!filledData?.revenue_model ? 'border-red-500' : ''} `}
                                    borderColor="brand.primary"
                                    placeholder={`outline your startup's revenue generation strategy or business model`}
                                />
                                <Text
                                    fontWeight={500}
                                    fontSize="16px"
                                    color="#000"
                                    ref={revenueModelRef}
                                >
                                    Competition{' '}
                                    {!filledData?.competition && (
                                        <Text className="text-red-600 text-lg inline font-bold">
                                            *
                                        </Text>
                                    )}
                                </Text>
                                <Textarea
                                    name="competition"
                                    defaultValue={filledData?.competition}
                                    // value={filledData?.competition}
                                    onChange={handleChange}
                                    maxLength={300}
                                    rows={4}
                                    borderRadius="10px"
                                    borderWidth={1}
                                    className={`border ${!filledData?.competition ? 'border-red-500' : ''} `}
                                    borderColor="brand.primary"
                                    placeholder={`List your competitors and how the startup differentiates from them`}
                                />
                                <Text
                                    fontWeight={500}
                                    fontSize="16px"
                                    color="#000"
                                    ref={competitionRef}
                                >
                                    Use of funds{' '}
                                    {!filledData?.fund_use && (
                                        <Text className="text-red-600 text-lg inline font-bold">
                                            *
                                        </Text>
                                    )}
                                </Text>
                                <Textarea
                                    name="fund_use"
                                    defaultValue={filledData?.fund_use}
                                    // value={filledData?.fund_use}
                                    onChange={handleChange}
                                    maxLength={300}
                                    rows={4}
                                    borderRadius="10px"
                                    borderWidth={1}
                                    className={`border ${!filledData?.fund_use ? 'border-red-500' : ''} `}
                                    borderColor="brand.primary"
                                    placeholder={`Specify how you plan to allocate funds to various aspects of your startup`}
                                />
                                <Text
                                    fontWeight={500}
                                    fontSize="16px"
                                    color="#000"
                                    ref={fundsUseRef}
                                >
                                    Current Investors{' '}
                                    {!filledData?.stakeholders && (
                                        <Text className="text-red-600 text-lg inline font-bold">
                                            *
                                        </Text>
                                    )}
                                </Text>
                                <Textarea
                                    name="stakeholders"
                                    defaultValue={filledData?.stakeholders}
                                    // value={filledData?.stakeholders}
                                    onChange={handleChange}
                                    maxLength={300}
                                    rows={4}
                                    borderRadius="10px"
                                    borderWidth={1}
                                    className={`border ${!filledData?.stakeholders ? 'border-red-500' : ''} `}
                                    borderColor="brand.primary"
                                    placeholder={`If applicable, provide information about current investors or stakeholders`}
                                />
                                <Text
                                    fontWeight={500}
                                    fontSize="16px"
                                    color="#000"
                                    ref={stakeholdersRef}
                                >
                                    Customers{' '}
                                    {!filledData?.customer_type && (
                                        <Text className="text-red-600 text-lg inline font-bold">
                                            *
                                        </Text>
                                    )}
                                </Text>
                                <Textarea
                                    name="customer_type"
                                    defaultValue={filledData?.customer_type}
                                    // value={filledData?.customer_type}
                                    onChange={handleChange}
                                    maxLength={300}
                                    rows={4}
                                    borderRadius="10px"
                                    borderWidth={1}
                                    className={`border ${!filledData?.customer_type ? 'border-red-500' : ''} `}
                                    borderColor="brand.primary"
                                    placeholder={`Details about the target customer base are essential`}
                                />

                                <div className="w-full">
                                    <Text
                                        fontWeight={500}
                                        fontSize="16px"
                                        color="#000"
                                    >
                                        Website URL{' '}
                                        {!filledData?.website_url && (
                                            <Text className="text-red-600 text-lg inline font-bold">
                                                *
                                            </Text>
                                        )}
                                    </Text>
                                    <Input
                                        key="website_url"
                                        type="url"
                                        placeholder="https://example.com"
                                        name="website_url"
                                        value={filledData?.website_url}
                                        onChange={handleChange}
                                        onBlur={(e) => {
                                            const value = e.target.value;
                                            if (value && !isValidUrl(value)) {
                                                setWebsiteUrlError(
                                                    'Please enter a valid URL starting with https://',
                                                );
                                            } else {
                                                setWebsiteUrlError('');
                                            }
                                        }}
                                        borderRadius="10px"
                                        borderWidth={1}
                                        h="50px"
                                        className={`border ${websiteUrlError ? 'border-red-500' : ''}`}
                                    />
                                    {websiteUrlError && (
                                        <Text color="red.500" fontSize="sm" mt={1}>
                                            {websiteUrlError}
                                        </Text>
                                    )}
                                </div>
                                <div ref={customerTypeRef}></div>
                            </>
                        ) : null}
                        {accountType === 'investor' ? (
                            <>
                                <Box>
                                    <Page
                                        question="What company stage are you interested in?"
                                        options={surveyData?.companyStages}
                                        data={{ companyStageId: undefined }}
                                        setFilledData={setFilledData}
                                        filledData={filledData}
                                        isCheckBox={true}
                                        pageContainerClasses={'w-full items-start'}
                                        isOnboardingView={false}
                                        responseId={companyDetails?.company_stage_ids.map(
                                            (item) => `${item}`,
                                        )}
                                    />
                                    <Page
                                        question="How much money are you interested in investing?"
                                        options={surveyData?.fundCategories}
                                        data={{ fundCategoryId: undefined }}
                                        setFilledData={setFilledData}
                                        filledData={filledData}
                                        responseId={companyDetails?.fundCategoryId}
                                        pageContainerClasses={'w-full items-start'}
                                        isOnboardingView={false}
                                    />

                                    <Page
                                        question="Where would you like to invest in?"
                                        isCheckBox={true}
                                        options={surveyData?.locations}
                                        data={{ investmentlocationId: undefined }}
                                        setFilledData={setFilledData}
                                        filledData={filledData}
                                        responseId={companyDetails?.investment_location_ids?.map(
                                            (item) => `${item}`,
                                        )}
                                        pageContainerClasses={'w-full items-start'}
                                        isOnboardingView={false}
                                    />
                                    <Page
                                        question="Where is your company incorporated?"
                                        isCheckBox={true}
                                        options={surveyData?.locations}
                                        data={{ incorporationLocationId: undefined }}
                                        setFilledData={setFilledData}
                                        filledData={filledData}
                                        responseId={companyDetails?.incorporation_location_ids.map(
                                            (item) => `${item}`,
                                        )}
                                        pageContainerClasses={'w-full items-start'}
                                        isOnboardingView={false}
                                    />
                                    <Page
                                        question="Which business models match your investment interest?"
                                        isCheckBox={true}
                                        options={surveyData?.businessModels}
                                        data={{ businessModelId: undefined }}
                                        setFilledData={setFilledData}
                                        filledData={filledData}
                                        pageContainerClasses={'w-full items-start'}
                                        isOnboardingView={false}
                                        responseId={companyDetails?.business_model_ids?.map(
                                            (item) => `${item}`,
                                        )}
                                    />
                                    <Page
                                        question="Which business category would you like to invest in?"
                                        options={surveyData?.categories}
                                        isCheckBox={true}
                                        data={{ businessCategoryId: undefined }}
                                        setFilledData={setFilledData}
                                        filledData={filledData}
                                        pageContainerClasses={'w-full items-start'}
                                        isOnboardingView={false}
                                        responseId={companyDetails?.business_category_ids?.map(
                                            (item) => `${item}`,
                                        )}
                                    />
                                </Box>
                            </>
                        ) : null}
                        <Box className="flex flex-col lg:flex-row gap-3 w-full space-between items-center">
                            <BrandButton
                                text="Submit"
                                width="full"
                                colorScheme="blue"
                                isLoading={isLoading}
                                onClick={submitCompanydata}
                                disabled={isCompanyFormIncomplete()}
                            />
                            <BrandButton
                                text="Cancel"
                                width="full"
                                onClick={closeEditSurvey}
                            />
                        </Box>
                    </VStack>
                </Box>
            )}
        </>
    )
}

export default CompanyProile